export const WALLET_QUICK_AMOUNTS = [5000, 10000, 25000] as const;

export const INSIGHTS_WINDOW_DAYS = 30;
export const INSIGHTS_FETCH_PAGE_SIZE = 500;

export const RUNWAY_HEALTHY_DAYS = 30;
export const RUNWAY_LOW_DAYS = 10;

export const SPARKLINE_POINTS = 20;

export const TRANSACTION_PAGE_SIZE_OPTIONS = [20, 50, 100] as const;
export const DEFAULT_TRANSACTION_PAGE_SIZE = 20;

export const TRANSACTION_TYPE_LABELS = ['UNKNOWN', 'CREDIT', 'DEBIT', 'RESERVE', 'RELEASE', 'SETTLE'] as const;

export type TransactionTypeIndex = 0 | 1 | 2 | 3 | 4 | 5;

export type TransactionSortOption = 'date-desc' | 'date-asc' | 'amount-desc' | 'amount-asc';

export const TRANSACTION_SORT_OPTIONS: { value: TransactionSortOption; label: string }[] = [
	{ value: 'date-desc', label: 'Newest first' },
	{ value: 'date-asc', label: 'Oldest first' },
	{ value: 'amount-desc', label: 'Highest amount' },
	{ value: 'amount-asc', label: 'Lowest amount' },
];
